import axios from 'axios';
import logger from '@/logger';

const ax = axios.create({
  baseURL: '/api',
});

async function tryRequest(p) {
  try {
    const response = await p;
    return response.data;
  } catch (e) {
    if (!e.response) {
      logger.error('issue connecting to server', e);
      throw e;
    } else if (e.response.data) {
      const resp = e.response.data;
      throw resp.message || resp.error_type || resp;
    } else {
      logger.error('some unknown problem');
      throw e;
    }
  }
}

export async function checkLogin() {
  const data = await tryRequest(ax.get('/login'));
  return data.user;
}

export async function login({ email, password }) {
  const data = await tryRequest(ax.post('/login', { email, password }));
  return data.user;
}

export function logout() {
  return tryRequest(ax.post('/logout'));
}

export async function fetchOrgsWithKeys() {
  const data = await tryRequest(ax.get('/orgs_with_keys'));
  return data.orgs;
}

export async function newToken(orgId) {
  return tryRequest(ax.post(`/create_or_revoke/${orgId}`));
}

export function reassignReport(reportId, orgId) {
  return tryRequest(ax.post('/reassign_report', { report_id: reportId, org_id: orgId }));
}

export function fetchOrphanedReports() {
  return tryRequest(ax.get('/orphaned_reports'));
}

export function searchUsersByEmail(query) {
  return tryRequest(ax.get(`/users_by_email?q=${encodeURIComponent(query)}`));
}

export function changeEmail(userId, email) {
  return tryRequest(ax.post('/change_email', { user_id: userId, email }));
}

export async function fetchVarsFromDb() {
  const data = await tryRequest(ax.get('/vars_and_org_ids'));
  return data.vars;
}

export async function putNewVarAssociations(payload) {
  const data = await tryRequest(ax.put('/update_var_associations', payload));
  return data.status;
}

export function conferAndFetchVAR(userId) {
  return tryRequest(ax.post(`/value_added_resalers/${userId}`));
}

export function removeVAR(userId) {
  return tryRequest(ax.delete(`/value_added_resalers/${userId}`));
}



// WEBPACK FOOTER //
// ./src/store/modules/api.js